'use strict';

var react = require('@emotion/react');

const pillGroup = /*#__PURE__*/ react.css({
    display: "flex",
    gap: "4px"
}, "label:label-PillGroup-web-stylespillGroup", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2JlbmFpYWhiYXJhbmdvL2Rldi9hdmlhcnkvcGFja2FnZXMvYXZpYXJ5LXdlYi9zcmMvY29tcG9uZW50cy9tb2xlY3VsZXMvUGlsbEdyb3VwL1BpbGxHcm91cC53ZWIuc3R5bGVzLnRzIiwic291cmNlcyI6WyIvVXNlcnMvYmVuYWlhaGJhcmFuZ28vZGV2L2F2aWFyeS9wYWNrYWdlcy9hdmlhcnktd2ViL3NyYy9jb21wb25lbnRzL21vbGVjdWxlcy9QaWxsR3JvdXAvUGlsbEdyb3VwLndlYi5zdHlsZXMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0XCI7XG5cbmV4cG9ydCBjb25zdCBwaWxsR3JvdXAgPSBjc3Moe1xuICBkaXNwbGF5OiBcImZsZXhcIixcbiAgZ2FwOiBcIjRweFwiLFxufSk7XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRXlCIn0= */");

exports.pillGroup = pillGroup;
//# sourceMappingURL=PillGroup.web.styles.cjs.map
